/** @jsxImportSource theme-ui */
import { Box, Heading } from 'theme-ui';
import { useGetVossUsageQuery } from '@/store/apiService';
import { JSONTree } from 'react-json-tree';
import jsonTreeTheme from '@/theme/jsonTreeTheme';
import DataTable from '@/components/DataTable';
import { Container } from '@/components/styled';

type Props = {};

const tableColumns = [
    {
        columnKey: 'id',
        Header: 'Id',
        accessor: 'id',
        width: '50px',
    },
    {
        columnKey: 'status',
        Header: 'Status',
        accessor: 'status',
        width: '50px',
    },
    {
        columnKey: 'idempotencyKey',
        Header: 'Idempotency Key',
        accessor: 'idempotencyKey',
    },
    {
        columnKey: 'quantity',
        Header: 'Quantity',
        accessor: 'quantity',
        width: '50px',
    },
    {
        columnKey: 'currentQuantity',
        Header: 'Current Quantity',
        accessor: 'currentQuantity',
        width: '50px',
    },
    {
        columnKey: 'customer, product, period',
        Header: 'Customer, Product, Period',
        accessor: (row: any) =>
            [
                ...Object.values(row.customer),
                // ...Object.values(row.period),
                // ...Object.values(row.product),
            ].join(','),
        Cell: ({ row, cell }) => {
            return (
                <Box
                    sx={{
                        '& > ul': {
                            padding: (t: any) => `${t.space[2]} !important`,
                            borderRadius: (t: any) => `${t.radii['sm']} !important`,
                        },
                    }}
                >
                    <Heading as="h3">Customer</Heading>
                    <JSONTree
                        data={row.original.customer}
                        hideRoot={true}
                        theme={jsonTreeTheme}
                        invertTheme={true}
                        shouldExpandNodeInitially={(keyPath, data, level) => {
                            return true;
                        }}
                    />

                    <Heading as="h3">Period</Heading>
                    <JSONTree
                        data={row.original.period}
                        hideRoot={true}
                        theme={jsonTreeTheme}
                        invertTheme={true}
                        shouldExpandNodeInitially={(keyPath, data, level) => {
                            return true;
                        }}
                    />

                    <Heading as="h3">Product</Heading>
                    <JSONTree
                        data={row.original.product}
                        hideRoot={true}
                        theme={jsonTreeTheme}
                        invertTheme={true}
                        shouldExpandNodeInitially={(keyPath, data, level) => {
                            return true;
                        }}
                    />
                </Box>
            );
        },
    },
    {
        columnKey: 'created',
        Header: 'Created',
        accessor: 'created',
        width: '50px',
    },
];

const VossUsage = (props: Props) => {
    const usageState = useGetVossUsageQuery({});
    const usage = usageState.data?.CustomersUsage ? usageState.data.CustomersUsage : [];

    return (
        <Container>
            <Heading>Usages</Heading>
            <DataTable
                sx={{
                    td: {
                        borderBottomColor: 'gray.3',
                        borderBottomWidth: '1px',
                        borderBottomStyle: 'solid',
                    },
                }}
                header={true}
                sorting={true}
                filtering={true}
                columns={tableColumns}
                data={usage}
                isLoading={usageState.isLoading}
                isFetching={usageState.isFetching}
            />
        </Container>
    );
};

export default VossUsage;
